'use client';

import { Banner } from "@/components/shared/banner";

export const OurStoryHero = () => {
    return (
        <Banner
            variant="article"
            title="Our Story"
            description="At StudyStash, our mission is to deliver brilliant outcomes for every student, whatever their ability, starting point or learning goal. Meet our team who are striving to improve outcomes for all students and the institutions that serve them."
            articleImage="/team.jpg"
            articleImageAlt="StudyStash team at their West Midlands offices"
            aria-label="Our story introduction"
        />
    );
};
